module.exports = "/assets/data/986b0a23381e40af02d4288eca265d0a-LS16.data.json";